import { z } from 'zod';

const isDev = import.meta.env.MODE === 'development';

const configSchema = z.object({
  nodeEnv: z.enum(['development', 'production', 'test']).default('development'),
  port: z.number().default(3000),
  supabaseUrl: isDev ? z.string() : z.string().url(),
  supabaseKey: z.string().min(1),
  jwtSecret: isDev ? z.string() : z.string().min(32),
  campayAccessToken: z.string().min(1),
  campayWebhookKey: z.string().min(1),
  campayCallbackUrl: z.string().url(),
  paypalClientId: z.string().default(''),
  paypalSecret: z.string().default(''),
  stripePublicKey: z.string().min(1),
  stripeSecretKey: z.string().min(1),
  appUrl: z.string().default('http://localhost:5173')
});

export const config = configSchema.parse({
  nodeEnv: import.meta.env.VITE_NODE_ENV || 'development',
  port: import.meta.env.VITE_PORT ? parseInt(import.meta.env.VITE_PORT) : undefined,
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL,
  supabaseKey: import.meta.env.VITE_SUPABASE_KEY,
  jwtSecret: import.meta.env.VITE_JWT_SECRET,
  campayAccessToken: import.meta.env.VITE_CAMPAY_ACCESS_TOKEN,
  campayWebhookKey: import.meta.env.VITE_CAMPAY_WEBHOOK_KEY,
  campayCallbackUrl: import.meta.env.VITE_CAMPAY_CALLBACK_URL,
  paypalClientId: import.meta.env.VITE_PAYPAL_CLIENT_ID || '',
  paypalSecret: import.meta.env.VITE_PAYPAL_SECRET || '',
  stripePublicKey: import.meta.env.VITE_STRIPE_PUBLIC_KEY,
  stripeSecretKey: import.meta.env.VITE_STRIPE_SECRET_KEY,
  appUrl: import.meta.env.VITE_APP_URL || 'http://localhost:5173'
});